import { CIcon } from '~/icons/types'

export const ciMotorbikes: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M8.438 14.477c.004.253-.02.516-.061.774l-.178 1.022a.497.497 0 0 0 .45.577l6.993.477h.033a.49.49 0 0 0 .488-.515s-.329-1.622-.254-2.658c.094-1.294.732-2.456 1.861-3.08.127-.07.253-.131.385-.187l.051-.019c.291-.113.586-.202.891-.263l.014-.004a4.37 4.37 0 0 1 .816-.066l.947.019a.943.943 0 0 0 .848-1.383l-.23-.426a5.496 5.496 0 0 0-2.268-2.297L16.908 5.07a.491.491 0 0 0-.675.173.491.491 0 0 0 .169.675l1.71 1.017L16.59 8.15a3.927 3.927 0 0 0-2.348-1.13l-.422-.046h-.028c-.544-.028-1.903-.005-2.757.886l-.637.665H8.349l-.474-.628a2.477 2.477 0 0 0-2.067-.951l-4.04.187a.494.494 0 0 0-.235.914c-.155-.122 3.108 1.552 4.8 2.653.91.596 1.664 1.402 1.973 2.799l.01.033c.065.285.108.576.122.867v.08Z'
    },
    {
      d:
        'M3.614 18.364a3.607 3.607 0 0 0 3.614-3.6c0-1.988-1.618-3.6-3.614-3.6A3.607 3.607 0 0 0 0 14.764c0 1.988 1.618 3.6 3.614 3.6Zm16.851-.001A3.525 3.525 0 0 0 24 14.848a3.525 3.525 0 0 0-3.535-3.516 3.525 3.525 0 0 0-3.534 3.516 3.525 3.525 0 0 0 3.534 3.515Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'motorbikes',
  type: 'solid'
}
